import React, {useContext} from 'react';
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {handleImageUrl, slugify} from "../../helpers";
import {Link} from "react-router-dom";
import {LangContext} from "../../App";

const TourListItem = ({tour,path}) => {
    const lang = useContext(LangContext)
    if (!tour) return null;
    const slug = slugify(tour?.title || '')
    const image = handleImageUrl(tour.thumbnail)
    return (
        <Link to={`/${lang}/${path}/${tour.id}/${slug}`} className='tour-list-item'>
            {image && <img src={image} alt="ayr"/>}
            <div className="description">
                <div className="d-flex flex-column">
                    <div className='d-flex location'>
                        <FontAwesomeIcon icon={faLocationDot} className='icon'/>
                        {tour?.city}
                    </div>
                    <div className="d-flex date text-body">
                        {tour?.title && tour?.title}
                    </div>
                </div>
                <div className="d-flex align-items-end">
                    <p className="price">${tour.price}</p>
                </div>
            </div>
        </Link>
    );
};

export default TourListItem;